var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass:
        "TcHome container px-5 flex-1 mx-auto flex items-center gap-5 h-full"
    },
    [
      _c(
        "button",
        {
          staticClass: "flex-1 btn btn-jumbo",
          on: {
            click: function($event) {
              return _vm.$root.setPage("new-appointment")
            }
          }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }
            },
            [
              _c("path", {
                attrs: {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Cita previa")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "flex-1 btn btn-jumbo",
          on: {
            click: function($event) {
              return _vm.$root.setPage("events-list")
            }
          }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }
            },
            [
              _c("path", {
                attrs: {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d:
                    "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "text-left" }, [
            _vm._v("Inscripción Eventos / Actividades")
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }